import React, { useEffect, useState } from "react";

export interface Orientation {
  orientation: number | undefined;
}

export function useOrientation(): Orientation {
  const [orientation, setOrientation] = useState<Orientation>({
    orientation: undefined,
  });

  useEffect(() => {
    const orientationEvent: string =
      "onorientationchange" in window ? "orientationchange" : "resize";

    function handleOrientation() {
      setOrientation({
        orientation: window.orientation,
      });
    }

    window.addEventListener(orientationEvent, handleOrientation);

    handleOrientation();
    return () =>
      window.removeEventListener(orientationEvent, handleOrientation);
  }, []);
  return orientation;
}
